module.exports = __webpack_public_path__ + "static/media/icon-com-agenda2.9ef80ba2.svg";